import * as moment from "moment";
import { isDevMode } from '@angular/core';


export class Util {

  //static url = (isDevMode())?`http://localhost:3000`:`http://amarante.appwepro.com`
  static url = `https://amarante.appwepro.com`
  //static url = `http://localhost:3000`

  static getDefaultStartDate(){
    var m = moment().subtract(3,'months');
    var startDate = {year: parseInt(m.format('YYYY')), month: parseInt(m.format('M')), day:parseInt(m.format('D'))};
    return startDate;

  }

  static getDefaultEndDate(){
    var m = moment();
    var date = {year: parseInt(m.format('YYYY')), month: parseInt(m.format('M')), day:parseInt(m.format('D'))};
    return date;
  }

  static setHeaderToken(headers: any) {
    var currentUser = JSON.parse(localStorage.getItem('currentUser'))
    var uuid = localStorage.getItem('uuid')
    if (currentUser) {
      headers.delete('token')
      headers.append('token', currentUser.token)
    }
    return headers
  }


  static cloneProp(from_obj,to_obj){
    if(from_obj) {
      Object.keys(from_obj).map((key, index) => {
        if (to_obj.hasOwnProperty(key)) {
          to_obj[key] = from_obj[key]
        }
      })
    }
    return to_obj
  }

  static fillDigit(n, width, z='0') {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }
}



// WEBPACK FOOTER //
// ./src/app/util/util.ts